const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-legal">
        <div className="footer-col">
          <p className="copyright">
            Copyright © {new Date().getFullYear()} SALTO SYSTEMS, S.L.
            <br /> All rights reserved.
          </p>
        </div>
        <div className="footer-col">
          <ol className="legalNav">
            <li>
              <a
                href="https://www.saltosystems.com/en/legal/legal-data/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Legal Data
              </a>
            </li>
            <li>
              <a
                href="https://www.saltosystems.com/en/legal/legal-data/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href="https://www.saltosystems.com/en/legal/legal-data/cookies-policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Cookies Policy
              </a>
            </li>
          </ol>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
